<div class="cargando" *ngIf="undefined === servicios">
    <p>Cargando<span>.</span><span>.</span><span>.</span></p>
</div>

<div class="empty" *ngIf="servicios && servicios.length === 0">
    <p>No hay servicios relacionados con este expediente.</p>
</div>

<div class="servicio-list" *ngIf="servicios && servicios.length > 0">

    <article class="servicio-card" *ngFor="let s of servicios">

        <span class="servicio-strip" aria-hidden="true"></span>

        <span class="servicio-icon" aria-hidden="true">
            <svg viewBox="0 0 42 42" fill="none" stroke="#00558c" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="5" width="14" height="14" rx="2"/>
                <rect x="23" y="5" width="14" height="14" rx="2"/>
                <rect x="5" y="23" width="14" height="14" rx="2"/>
                <rect x="23" y="23" width="14" height="14" rx="2"/>
            </svg>
        </span>

        <div class="servicio-col servicio-col--fixed">
            <div class="servicio-field">
                <p class="label">Nº de servicio:</p>
                <p class="value">{{ s.serviceNumber }}</p>
            </div>
            <div class="servicio-field">
                <p class="label">Nombre:</p>
                <p class="value">{{ s.serviceName }}</p>
            </div>
        </div>

        <span class="servicio-divider" aria-hidden="true"></span>

        <div class="servicio-col servicio-col--fixed">
            <div class="servicio-field">
                <p class="label">Tipo de servicio:</p>
                <p class="value">{{ s.serviceType }}</p>
            </div>
        </div>

        <span class="servicio-divider" aria-hidden="true"></span>

        <div class="servicio-col">
            <div class="servicio-field">
                <p class="label">Especialidad:</p>
                <p class="value">{{ s.serviceSpecialty }}</p>
            </div>
            <div class="servicio-field">
                <p class="label">Teléfono:</p>
                <p class="value">{{ s.servicePhone }}</p>
            </div>
        </div>

        <span class="servicio-divider" aria-hidden="true"></span>

        <div class="servicio-col">
            <div class="servicio-field">
                <p class="label">Estado:</p>
                <p class="value">{{ s.serviceStatus }}</p>
            </div>
            <div class="servicio-field">
                <p class="label">Email:</p>
                <p class="value breakword">{{ s.serviceEmail }}</p>
            </div>
        </div>

        <span class="servicio-divider" aria-hidden="true"></span>

        <div class="servicio-col">
            <div class="servicio-field">
                <p class="label">Fecha:</p>
                <p class="value">{{ s.serviceDate }}</p>
            </div>
        </div>

    </article>

</div>
